document.addEventListener('DOMContentLoaded', function() {
	
	if( $('.page__rating .rateit').length > 0 ){

        var rated = false;
        var rating = 0;
        var ID = '';

		$('.page__rating .rateit').rateit({
            resetable: false
        });
        
		$('.page__rating .rateit').on('rated', function(event, value) {

			$.ajax({
					type: 'POST',
					url: $(this).attr('data-ajaxbase').replace(/\/?$/, "/") + 'feedback',
					data: {PageID: $(this).attr('data-pageid'), PageLink: $(this).attr('data-ajaxbase'), Rating: value},
					success: function(response){
						ID = response;
						$('.score').html('You have given this page a rating of <span class="page-rating"></span> out of 5 stars');
						$('.page-rating').text(value);
						if (rated == false) {
						$('.comments').slideToggle();
						rated = true;
					}
					}
				});	

			});
		
		$(document).on('click', '#comment-submit', function(e) {
			e.preventDefault();
			var form = $('.ajax-rateit-form');
			var data = form.serializeArray();
			data.push({name: "Feedback", value: $('#comment-text').val()});
			data.push({name: "FeedbackID", value: ID});
			
			$.ajax({
				type: 'POST',
				url: $('.rateit').attr('data-ajaxbase').replace(/\/?$/, "/") + 'feedbackcomment',
				data: $.param(data),
				success: function(response){
					if(response == 'Success'){
						$('.comments').slideToggle();
						$('.thank-you').show();
						$('#comment-text').val('');
						rated = false;
					} else{
						$('.ajax-rateit-form').append("<p>"+response+"</p>");
					}
				}
			});	

        });
        
        $(document).on('click', '.comments span', function() {
		$('#comment-text').val('');
            $('.comments').slideToggle();
            rated = false;
        });
    }

});